import SimpleQuestion from "./SimpleQuestion";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import * as theme from "../theme";
import { INSURER, YES, NO } from "../store/businesslogic/hardwiredlogic";
import { useRef } from "react";
import { useStylesLocally } from "../muithemeclasses";
import {
  getBrokerInformation,
  retrieveBrokerageImg,
  retrieveBrokerforClient,
} from "../store/broker";
import translations from "../utils/translations";
import { useDispatch, useSelector } from "react-redux";

const YesNo = ({
  text,
  node,
  handleAnswerChange,
  isNodeOpen,
  qfusermode,
  stylecss,
}) => {
  return (
    <SimpleQuestion
      leftString={text}
      node={node}
      stylecss={stylecss}
      rightComponent={
        <YesNoRadio
          node={node}
          stylecss={stylecss}
          handleAnswerChange={handleAnswerChange}
          qfusermode={qfusermode}
        ></YesNoRadio>
      }
    ></SimpleQuestion>
  );
};

export const YesNoRadio = ({
  node,
  handleAnswerChange,
  qfusermode,
  stylecss,
  value
}) => {
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  const handleAnswer = (event) => {
    handleAnswerChange(event.target.value);
  };

  const handleKeyPress = ({ event, value }) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleAnswerChange(value);
    }
  };

  const handleClick = (event) => {
    if (node.answer == event.target.value) {
      handleAnswerChange(null);
    }
  };

  const classes = useStylesLocally();

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        paddingTop: "1vmin",
      }}
    >
      <FormControl>
        <RadioGroup
          row
          key={node.id}
          aria-label="gender"
          name="gender1"
          value={value !== undefined ? value : node.answer ? node.answer : ""}
          onChange={handleAnswer}
          onClick={handleClick}
        >
          &nbsp;&nbsp;&nbsp;&nbsp;
          <FormControlLabel
            value={YES}
            classes={{
              root: classes.formControllLabelRoot,
            }}
            control={
              <Radio
                color="default"
                name="rd1"
                tabIndex={-1}
                classes={{ root: classes.rootForYesNo }}
                id={`YesNo_${node.id}_Yes`}
                inputProps={{
                  questionid: `${node.id}`,
                  questiontype: "YesNo",
                  questionValue: "Yes",
                }}
              />
            }
            label={
              <YesNoTextOnly
                stylecss={stylecss}
                text={translations[languagepreference].yes}
              ></YesNoTextOnly>
            }
            disabled={qfusermode === INSURER ? true : false}
            tabIndex={0}
            onKeyPress={(event) => handleKeyPress({ event, value: YES })}
          />
          &nbsp;&nbsp;&nbsp;&nbsp;
          <FormControlLabel
            value={NO}
            classes={{
              root: classes.formControllLabelRoot,
            }}
            control={
              <Radio
                color="default"
                name="rd2"
                tabIndex={-1}
                classes={{ root: classes.rootForYesNo }}
                id={`YesNo_${node.id}_No`}
                inputProps={{
                  questionid: `${node.id}`,
                  questiontype: "YesNo",
                  questionValue: "No",
                }}
              />
            }
            label={
              <YesNoTextOnly
                stylecss={stylecss}
                text={translations[languagepreference].no}
              ></YesNoTextOnly>
            }
            disabled={qfusermode === INSURER ? true : false}
            tabIndex={0}
            onKeyPress={(event) => handleKeyPress({ event, value: NO })}
          />
        </RadioGroup>
      </FormControl>
    </div>
  );
};

const YesNoTextOnly = ({ text, stylecss }) => {
  return (
    <div
      style={{
        fontFamily: "GibsonRegular",
        color: stylecss?.textColor
          ? stylecss.textColor
          : theme.COLORS.primary_navyblue,
        letterSpacing: 1,
        fontSize: "1.6vmin",
      }}
    >
      {text}
    </div>
  );
};

export const YesNoRadioForMiniForm = ({
  code,
  questionid,
  node,
  handleAnswerChange,
  qfusermode,
}) => {
  // const handleAnswer = (event) => {
  //   handleAnswerChange(event.target.value);
  // };

  const decideTheValue = (code, node, questionid) => {
    if (!node) return "";
    if (!node.answer) return "";
    if (!node.answer.internal) return "";
    if (!node.answer.internal[code]) return "";
    if (!node.answer.internal[code][questionid]) return "";

    return node.answer.internal[code][questionid];
  };

  const handleChange = (event) => {
    handleAnswerChange(code, questionid, event.target.value);
  };

  return (
    <FormControl>
      <RadioGroup
        row
        key={node.id}
        aria-label="gender"
        name="gender1"
        value={decideTheValue(code, node, questionid)}
        onChange={handleChange}
      >
        &nbsp;&nbsp;&nbsp;&nbsp;
        <FormControlLabel
          value={YES}
          control={<Radio style={{ color: "white" }} />}
          label={YES}
          disabled={qfusermode === INSURER ? true : false}
        />
        &nbsp;&nbsp;&nbsp;&nbsp;
        <FormControlLabel
          value={NO}
          control={<Radio style={{ color: "white" }} tabIndex={-1} />}
          label={NO}
          disabled={qfusermode === INSURER ? true : false}
        />
      </RadioGroup>
    </FormControl>
  );
};

export default YesNo;
